import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule as Formly } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { RepeatObservationsComponent } from '../../components/observations-modal/repeat-observations';
import { CheckboxFieldType } from './checkbox.type';
import { InputFieldType } from './input-field.component';
import { MultiSelectFieldType } from './multi-select.component';
import { MultiSelectType } from './multi-select.type';
import { MultiType } from './multi.type';
import { RepeatComponent } from './repeat';
import { RepeatTypeComponent } from './repeat-section.type';
import { SelectFieldType } from './select-field.component';
import { TagsType } from './tags.type';

@NgModule({
  declarations: [InputFieldType, SelectFieldType, RepeatTypeComponent, RepeatComponent, RepeatObservationsComponent, MultiSelectFieldType, TagsType, MultiType, CheckboxFieldType, MultiSelectType],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlySelectModule,
    Formly.forRoot({
      types: [
        { name: 'input', component: InputFieldType },
        { name: 'select', component: SelectFieldType },
        { name: 'repeat', component: RepeatTypeComponent },
        { name: 'repeat2', component: RepeatComponent},
        { name: 'tags', component: TagsType},
        // { name: 'tags2', component: Tags2Type},
        { name: 'multi-select', component: MultiSelectFieldType},
        { name: 'multi', component: MultiType},
        //{ name: 'multi-tree', component: MultiTreeType},
        { name: 'checkbox', component: CheckboxFieldType },
        { name: 'multi-select-people', component: MultiSelectType},
      ],
    }),
    NgSelectModule,
    NgxTolgeeModule,
    FontAwesomeModule,
    // TuiRootModule,
    // TuiInputTagModule,
    // TuiTextfieldControllerModule
  ],
  exports: [
    ReactiveFormsModule,
    Formly
  ],
})
export class FormlyModule {}
